import React from 'react';
import { connect } from 'react-redux';

import { toggleChat } from 'apps/promo/actions/chatAction';
import { Breadcrumbs } from 'apps/promo/components/common/breadcrumbs/Breadcrumbs';
import ColoredSectionContainer from 'apps/promo/components/common/ColoredSectionContainer';
import { PromoIcon } from 'apps/promo/components/common/promo-icon/PromoIcon';
import { PromoPageContainer } from 'apps/promo/components/common/promo-page-container/PromoPageContainer';
import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';
import { PromoRow } from 'apps/promo/components/common/PromoRow/PromoRow';
import HeadingSection from 'apps/promo/components/common/sections/HeadingSection';
import ZendeskHelpSearch from 'apps/promo/components/help/ZendeskHelpSearch';
import NotAuthBasePage from 'apps/promo/components/NotAuthBasePage';
import { getHelpCenterUrl, useGetQueryParams } from 'apps/promo/components/utils';
import { getLangCountryPrefix } from 'apps/promo/helpers/utils';

import styles from './ZendeskHelp.module.css';

const ZendeskHelpCategoryPage = (props) => {
    const category = props.category;

    const url = `${getLangCountryPrefix(props.lang, props.country)}/help`;
    const urlParams = useGetQueryParams();

    const filteredSections = props.sections?.filter((section) => {
        return section.category_id === category?.id && !section.directLink;
    });

    const sections = filteredSections?.map((item) => {
        return (
            <PromoRow indent="adaptive-24-32" key={item.id} lastChildNoMargin>
                <a className={styles.helpLink} href={getHelpCenterUrl(`${url}/category/${item.category_id}/section/${item.id}`, urlParams)}>
                    <PromoText variant="h4">{item.name}</PromoText>
                    <PromoIcon name="chevron-right" size="24px" />
                </a>
            </PromoRow>
        );
    });

    const breadcrumbs = [{ name: 'Paysend', url: getHelpCenterUrl(url, urlParams) }, { name: category?.name }];

    return (
        <PromoPageContainer hasTopPadding>
            <ColoredSectionContainer dimension="average" bottomPadding noTopPadding>
                <ZendeskHelpSearch />
                <Breadcrumbs breadcrumbsItems={breadcrumbs} />
                <HeadingSection title={category?.name} titleTag={'h1'} />
                <PromoRow indent="64px">{sections}</PromoRow>
            </ColoredSectionContainer>
        </PromoPageContainer>
    );
};

const mapStateToProps = ({ extra }) => ({
    category: extra?.zendeskHelpData?.category,
    sections: extra?.zendeskHelpData?.sections,
    lang: extra.noAuthFooter?.language?.lang,
    country: extra.noAuthFooter?.language?.country,
});

export default connect(mapStateToProps, { toggleChat })(NotAuthBasePage(ZendeskHelpCategoryPage));
